IpixJson.options.flatpicker = {
    enableTime: false,
};
